'use strict';

var $ = require('jquery');
var util = require('../../utils/util');
var ajax = require('../../utils/ajax');
var colorSwatch = require('./colorswatch');
var optiExperiment = require('../../components/optimizelyExperimentation');
import {debounce} from '../../components/custom-lodash';

function gridViewToggle() {
    $('.toggle-grid').on('click', function () {
        $('.search-result-content').toggleClass('wide-tiles');
        $(this).toggleClass('wide');
    });
}

/**
 * @private
 * @function
 * @description Initializes events on the hover-view tile for the following elements:
 * - thumbnails
 */
function initHoverViewEvents($hoverView) {
    var inited = false;
    var $thumbnails;
    var $mainTileImage;
    var thumbImageSrc = '';
    var mainTileImageSrc;
    if ($hoverView) {
        $thumbnails = $hoverView.find('.product-color-thumbnails-list li');
        $mainTileImage = $hoverView.find('.product-image img');
        $mainTileImage.on('load', function () {
            $hoverView.fadeIn();
            inited = true;
        });
        colorSwatch.initContainerSwatches($hoverView);
        mainTileImageSrc = $mainTileImage.attr('src') || $mainTileImage.data('src');
        $thumbnails.each(function () {
            $(this).on('mouseover', function () {
                var $thumbImg = $(this).find('img');
                var dataObj = null;
                if ($thumbImg.length > 0 && $thumbImg.data('lgimg')) {
                    dataObj = $thumbImg.data('lgimg');
                    thumbImageSrc = dataObj.tileUrl || '';
                }

                if (thumbImageSrc.length > 0 && inited) {
                    $mainTileImage.attr('src', thumbImageSrc);
                }
            });

            $(this).on('mouseout', function () {
                if (thumbImageSrc.length > 0 && inited) {
                    $mainTileImage.attr('src', mainTileImageSrc);
                }
            });
        });
    }

    $('.grid-tile [title]').removeAttr('title');
}

/**
 * @private
 * @function
 * @description Adjusts the height of grid tiles (product tiles and category banners) to be the same for all tiles.
 */
function adjustPromoTeaserPosition() {
    var $categoryPromotion = $('.category-promotion');

    if (window.innerWidth <= Breakpoints.Grid) {
        for (var i = 0; i < $categoryPromotion.length; i++) {
            var teaser = $($categoryPromotion[i]);
            if (teaser.hasClass('asset-width-2') || teaser.hasClass('asset-width-3')) {
                if (!teaser.hasClass('adjusted')) {
                    var teserIndex = parseInt(teaser.attr('data-idx'));
                    var teaserPos = teserIndex + 1;
                    if (teaserPos % 2 == 0) {
                        var prevTeaser = teaser.prev();
                        teaser.insertBefore(prevTeaser);
                        teaser.attr('data-idx', teserIndex - 1);
                    }

                    teaser.addClass('adjusted');
                }
            }
        }
    } else {
        for (var i = 0; i < $categoryPromotion.length; i++) {
            var teaser = $($categoryPromotion[i]);
            var teserIndex = parseInt(teaser.attr('data-idx'));
            var teaserPos = teserIndex + 1;
            if (teaserPos != teaser.attr('data-position')) {
                var nextTeaser = teaser.next();
                teaser.insertAfter(nextTeaser);
                teaser.attr('data-idx', teserIndex + 1);
                teaser.removeClass('adjusted');
            }
        }
    }
}
/**
 * @private
 * @function
 * @description Adjusts the row position of the promo tiles.
 */
function adjustPromoRowPosition() {
    var $searchResultItems = $('.search-result-items .grid-tile');
    var $promotionRowsWrapper = $('.promotional-rows-wrapper');
    var $promotionalRows = $promotionRowsWrapper.find('.promotional-row');

    if ($promotionalRows.length === 0) {
        return;
    }

    if ($searchResultItems.length === 0) {
        return;
    }

    var searchResultOnRow = 3;
    $promotionalRows.sort(function (a, b) {
        return Number($(b).attr('data-position')) - Number($(a).attr('data-position'));
    });

    for (let i = $promotionalRows.length - 1; i >= 0; i--) {
        var element = $($promotionalRows[i]);
        var position = element.attr('data-position');
        var rowPosition = position * searchResultOnRow - 4;

        if (window.innerWidth <= Breakpoints.Grid) {
            if (!(rowPosition % 2)) {
                rowPosition -= 1;
            }
        }

        if (rowPosition < $searchResultItems.length) {
            element.insertAfter($searchResultItems.eq(rowPosition));
            $promotionalRows.splice(i, 1);
        }
    }

    $('.custom-height').each(function () {
        var element = $(this);
        var customStyle = element.attr('style');
        element.find('img').attr('style', customStyle);
    });
}

/**
 * @private
 * @function
 * @description Initializes events on the product-tile for the following elements:
 * - swatches
 * - thumbnails
 */
function initializeEvents() {
    gridViewToggle();

    $(window)
        .resize(
            debounce(function () {
                adjustPromoTeaserPosition();
                adjustPromoRowPosition();
            }, 100)
        )
        .resize();

    $('.swatch-list').on('mouseleave', function () {
        // Restore current thumb image
        var $tile = $(this).closest('.product-tile');
        var $thumb = $tile.find('.product-image .thumb-link img').eq(0);
        var data = $thumb.data('current');

        $thumb.attr({
            src: data.src,
            alt: data.alt,
            title: data.title
        });
    });
    $('.swatch-list .swatch')
        .on('click', function (e) {
            var $tile = $(this).closest('.product-tile');
            var data;
            var $thumb;
            var currentAttrs;
            e.preventDefault();
            if ($(this).hasClass('selected')) {
                return;
            }

            $(this).closest('.swatch-list').find('.swatch.selected').removeClass('selected');
            $(this).addClass('selected');
            $tile.find('.thumb-link').attr('href', $(this).attr('href'));
            $tile.find('name-link').attr('href', $(this).attr('href'));

            data = $(this).children('img').filter(':first').data('thumb');
            $thumb = $tile.find('.product-image .thumb-link img').eq(0);
            currentAttrs = {
                src: data.src,
                alt: data.alt,
                title: data.title
            };
            $thumb.attr(currentAttrs);
            $thumb.data('current', currentAttrs);
        })
        .on('mouseenter', function () {
            // get current thumb details
            var $tile = $(this).closest('.product-tile');
            var $thumb = $tile.find('.product-image .thumb-link img').eq(0);
            var data = $(this).children('img').filter(':first').data('thumb');
            var current = $thumb.data('current');

            // If this is the first time, then record the current img
            if (!current) {
                $thumb.data('current', {
                    src: $thumb[0].src,
                    alt: $thumb[0].alt,
                    title: $thumb[0].title
                });
            }

            // Set the tile image to the values provided on the swatch data attributes
            $thumb.attr({
                src: data.src,
                alt: data.alt,
                title: data.title
            });
        });

    const featureDecision = optiExperiment.decideFeatureFlagVariation('plp');

    // show and hide hover view of product tiles
    $('.tiles-container .product-tile.has-hover-effect .product-image').on('mouseenter', async e => {
        if ($(e.target).parents('.slick-dots-custom').length) {
            return;
        }
        var $tile = $(e.currentTarget).parents('.product-tile');
        var $hoverView = $tile.find('.product-tile-hover-view');
        var $hoverViews = $('.search-result-items .product-tile-hover-view');
        var url;
        var pid;
        let genderInput = $('input[name="categoryGender"]');
        let categoryGender = genderInput.length ? genderInput.val() : '';

        if ($hoverView.hasClass('loaded')) {
            $hoverView.fadeIn();
            $hoverViews.not($hoverView).fadeOut();
        } else {
            pid = $tile.data('itemid');

            let params = {
                pid: pid,
                categoryGender: categoryGender
            };

            const quickShopVariation = (await featureDecision).variationKeyQuickshop;
            if (quickShopVariation && quickShopVariation !== 'off') {
                params.quickshopcase = quickShopVariation;
            }

            url = util.appendParamsToUrl(util.ajaxUrl(Urls.getProductHoverTile), params);

            if (!util.isMobile()) {
                ajax.load({
                    url: url,
                    target: $hoverView,
                    callback: function () {
                        $hoverView.addClass('loaded');
                        $hoverViews.not($hoverView).fadeOut();
                        initHoverViewEvents($hoverView);
                    }
                });
            }
        }
    });
    $('.tiles-container .product-tile.has-hover-effect').on('mouseleave', e => {
        var $hoverView = $(e.currentTarget).closest('.grid-tile').find('.product-tile-hover-view');
        $hoverView.stop(true, true).fadeOut();
    });

    $('.tiles-container .product-tile.has-hover-effect').on('click', e => {
        var $target = $(e.target);
        if ($target.hasClass('icon') || $target.hasClass('slick-slider') || $target.hasClass('slick-active')) {
            e.preventDefault();
        }
    });
}

exports.init = function () {
    var $tiles = $('.grid-tile');

    if ($tiles.length === 0) {
        return;
    }

    $tiles.each(function (idx) {
        $(this).attr('data-idx', idx);
    });

    initializeEvents();
};
